import React from "react";
import { ResponsiveDeviceType } from "../../layouts/ScreenMedia";

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export const MainContainer: React.FC<Props> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`main-container container px-3 px-md-0  ${className}`}>
      {children}
    </div>
  );
};

export const MainBodyContainer: React.FC<Props> = ({
  children,
  className = "",
}) => {
  const type: number = ResponsiveDeviceType();
  return (
    <div
      className={`main-container container ${
        type === 3 ? "h-100" : ""
      } py-3 px-4 px-md-0  ${className}`}
    >
      {children}
    </div>
  );
};

export const ChatContainer: React.FC<Props> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`main-container chat-container h-100`}>{children}</div>
  );
};
